import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import Navbar from "@/components/Navbar";
import { Button } from "@/components/ui/button";
import { Broadcast, CurrencyEur, Calendar } from "@phosphor-icons/react";

const ConcertCard = ({ c }) => {
  const when = new Date(c.scheduled_at);
  return (
    <Link
      to={`/concert/${c.id}`}
      data-testid={`concert-card-${c.id}`}
      className="group block rounded-2xl overflow-hidden border border-white/10 bg-[#0f0f10] hover:border-[#E11D48]/50 hover:-translate-y-1 transition-all duration-300"
    >
      <div className="relative aspect-video overflow-hidden">
        <img
          src={c.cover_image_url || "https://images.pexels.com/photos/26447525/pexels-photo-26447525.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"}
          alt={c.title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black via-black/30 to-transparent" />
        {c.is_live && (
          <div className="absolute top-3 left-3 flex items-center gap-2 px-3 py-1 rounded-full bg-red-600/90 text-xs font-bold uppercase tracking-wider">
            <span className="w-1.5 h-1.5 rounded-full bg-white animate-pulse" /> En direct
          </div>
        )}
        <div className="absolute bottom-3 right-3 px-3 py-1 rounded-full bg-black/80 backdrop-blur text-xs font-bold">
          {c.is_free ? "GRATUIT" : `${c.price_eur}€`}
        </div>
      </div>
      <div className="p-5">
        <div className="text-xs uppercase tracking-widest text-[#F59E0B] mb-2">{c.genre || "Live"}</div>
        <h3 className="font-display font-bold text-lg mb-1 leading-tight">{c.title}</h3>
        <p className="text-zinc-400 text-sm mb-3">par {c.artist_name}</p>
        <div className="flex items-center gap-4 text-xs text-zinc-500 font-mono">
          <span className="flex items-center gap-1"><Calendar size={14} /> {when.toLocaleDateString("fr-FR")} {when.toLocaleTimeString("fr-FR", { hour: "2-digit", minute: "2-digit" })}</span>
          <span className="flex items-center gap-1"><Broadcast size={14} /> {c.attendees_count} fans</span>
        </div>
      </div>
    </Link>
  );
};

const Concerts = () => {
  const [concerts, setConcerts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/concerts").then((r) => setConcerts(r.data)).finally(() => setLoading(false));
  }, []);

  return (
    <div className="min-h-screen bg-[#050505] text-white">
      <Navbar />
      <div className="max-w-7xl mx-auto px-6 py-14">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-10">
          <div>
            <p className="text-xs uppercase tracking-[0.3em] text-[#E11D48] font-bold mb-3">Programmation</p>
            <h1 className="font-display font-black text-4xl sm:text-5xl tracking-tight">Concerts à venir</h1>
          </div>
          <Button data-testid="concerts-create-btn" className="bg-[#E11D48] hover:bg-[#BE123C]" asChild>
            <Link to="/dashboard">Créer un concert</Link>
          </Button>
        </div>

        {loading ? (
          <p className="text-zinc-400">Chargement...</p>
        ) : concerts.length === 0 ? (
          <div className="border border-dashed border-white/10 rounded-2xl p-12 text-center">
            <p className="text-zinc-400">Aucun concert programmé pour le moment.</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {concerts.map((c) => <ConcertCard key={c.id} c={c} />)}
          </div>
        )}
      </div>
    </div>
  );
};

export default Concerts;
